// @flow

/**
 * Message List Component
 * Container for rendering all chat messages
 */

import { forwardRef } from 'react';
import styled from 'styled-components';
import MessageItem from './MessageItem';

const ChatWindow = styled.div`
  height: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: var(--panel-header-background);
  border: 1px solid var(--panel-header-background);
  border-radius: var(--widget-border-radius);
  font-family: var(--fonts-default);
`;

const MessageList = forwardRef(({ messages, activeStreamMessageId, onScroll, endRef }, ref) => {
  // using data-private stops logrocket from recording this on the replays
  // I don't know what that would do, but let's get this working
  return (
    <ChatWindow 
      aria-label="Chat history" 
      role="log" 
      ref={ref}
      onScroll={onScroll}
    >
      {messages.map((message) => (
        <MessageItem 
          key={message.id} 
          message={message}
          activeStreamMessageId={activeStreamMessageId}
        />
      ))}
      <div ref={endRef} />
    </ChatWindow>
  );
});

MessageList.displayName = 'MessageList';

export default MessageList;
